import { em } from 'polished'
import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
  padding-left: ${em(20)};
  padding-right: ${em(20)};
  text-align: center;
  padding-top: ${p => p.theme.blocks.menuHeight};
  min-height: 100vh;

  ${p => p.theme.mq.upMd} {
    text-align: left;
    padding-top: 0;
    min-height: initial;
  }
`

export const Content = styled.div`
  padding-bottom: ${em(40)};

  ${p => p.theme.mq.upMd} {
    display: flex;
    padding-top: ${em(20)};
    padding-bottom: ${em(20)};
  }
`

export const ContentBlock = styled.div`
  ${p => p.theme.mq.upMd} {
    padding-left: ${em(30)};
  }
`

export const IconBlock = styled.div`
  padding-bottom: ${em(20)};

  ${({ isEmpty }) =>
    isEmpty &&
    css`
      display: none;

      ${p => p.theme.mq.upMd} {
        display: block;
      }
    `}

  ${p => p.theme.mq.upMd} {
    padding-bottom: 0;
  }
`

export const Icon = styled.img`
  display: inline-block;
  width: ${em(120)};
`

export const AsideImageBox = styled.div`
  width: ${em(243)};
  margin: -${em(60)} auto -${em(30)};

  ${p => p.theme.mq.upMd} {
    position: absolute;
    margin: 0;
    top: -${em(68)};
    left: -${em(147)};
    width: ${em(333)};
  }
`
